// removed by extract-text-webpack-plugin
module.exports = {"container":"Jf1Nv","oops":"_2E08C","title":"_3OIBe"};


/*****************
 ** WEBPACK FOOTER
 ** ./web_modules/layouts/PageError/index.css
 ** module id = 506
 ** module chunks = 0
 **/